// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__m6Js0","image":"Header_image__1_-9k","name":"Header_name__1tGVm","info":"Header_info__1F3uj","infoRow":"Header_infoRow__1D6db"};